module.exports = __webpack_public_path__ + "media/images/font/SofiaPro-Bold-323e50f2b765a8fc86c58c226f71c3b8.ttf";